import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconNavigationArrowBack = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 12,
	fill: "none",
	viewBox: "0 0 12 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#9F9F9F",
		d: "M10 5.5H3.915L6.71 2.705 6 2 2 6l4 4 .705-.705L3.915 6.5H10v-1z"
	})
});
export default SvgIconNavigationArrowBack;
